// Resources
import API from "../helpers/API"
import { getLocalItem } from "../helpers/StorageTools"

/**
 * Componente funcional para manipulacão dos dados das taxas de entrega
 */
const DeliveryFeeController = {
  fetchDeliveryFee(type = "neighbourhood", companies = null, companyUid = null) {
    let headers = {}
    if (!!companyUid) headers = { company: companyUid }

    return API.request("/v1/delivery/fee", { type, companies }, "GET", headers)
  },

  fetchByneighbourhood(uuid_neighbourhood) {
    return API.request("/v1/delivery/fee/neighbourhood/" + uuid_neighbourhood, [], "GET")
  },

  calculate(latitude, longitude, neighbourhoodId, modalityId, customerAddressId, companyId, neighbourhoodName, origin, companyDatabase, companyUid) {
    let headers = {}
    const group = getLocalItem("group")
    if (group && companyUid) {
      headers = { company: companyUid }
    }

    return API.request(
      "/v1/fee/calculate",
      { latitude, longitude, neighbourhoodId, modalityId, customerAddressId, companyId, neighbourhoodName, origin, companyDatabase },
      "GET",
      headers
    )
  },
}

export default DeliveryFeeController
